import Vue from 'vue'

export default {
	async get(key: string | Array<string>) {
		try {
			let response = await Vue.prototype.$http.get('api/SystemSetting', { params: { keys: key } })
			return response.data
		} catch (error) {
			return {}
		}
	},
}
